import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import { ERROR } from "../../routes/path";
import { Header, MainColorButton } from "../../components";
import { bottomButton } from "../../common/styles";
import { closeWindow } from "../../utils/getLineProfile";

/**
 * 結果画面
 * @returns
 */
const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.header || !location.state?.message) {
      navigate(ERROR);
    }
  }, []);
  const { header, message } = location.state;
  return (
    <>
      <Header title={header} />
      <Box
        height="76vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Typography
          sx={{ fontSize: "110%", whiteSpace: "pre-wrap" }}
          align="left"
        >
          {message}
        </Typography>
      </Box>
      <MainColorButton
        label="閉じる"
        onClick={() => {
          closeWindow(navigate, location.state?.destination);
        }}
        style={bottomButton}
      />
    </>
  );
};

export default Result;
